/*
 *
 * Modal actions
 *
 */

import { genStrId } from 'utils/incrementalIdProvider';
import * as constants from './constants';

export function showOverlay() {
  return {
    type: constants.SHOW_OVERLAY,
    payload: {
      overlay: true,
    },
  };
}

export function hideOverlay() {
  return {
    type: constants.HIDE_OVERLAY,
    payload: {
      overlay: false,
    },
  };
}

export function pushToast(toast) {
  return {
    type: constants.PUSH_TOAST,
    toast: { ...toast, id: genStrId() },
  };
}

export function setToastsList(toasts) {
  return {
    type: constants.SET_TOASTS,
    toasts,
  };
}

export function removeToast({ toastId }) {
  return {
    type: constants.REMOVE_TOAST,
    toastId,
  };
}

export function incrementDownloadErrorReportsCount() {
  return {
    type: constants.INCREMENT_DOWNLOAD_ERROR_REPORTS_COUNT,
  };
}

export function decrementDownloadErrorReportsCount() {
  return {
    type: constants.DECREMENT_DOWNLOAD_ERROR_REPORTS_COUNT,
  };
}

export function updateToast(toast){
  return {
    type: constants.UPDATE_TOAST,
    payload: toast,
  };
}
